var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 46.9999C36.4786 46.9999 46.9999 36.4786 46.9999 23.5C46.9999 10.5213 36.4786 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4786 10.5213 46.9999 23.5 46.9999ZM21.7716 8.63223C22.5433 7.30879 24.4555 7.30879 25.2271 8.63223L38.5827 31.5373C39.3602 32.8706 38.3984 34.5448 36.855 34.5448H10.1438C8.60037 34.5448 7.63861 32.8706 8.41604 31.5373L21.7716 8.63223ZM24.4993 17.9477C24.4993 17.3954 24.0516 16.9477 23.4993 16.9477C22.947 16.9477 22.4993 17.3954 22.4993 17.9477V24.2157C22.4993 24.768 22.947 25.2157 23.4993 25.2157C24.0516 25.2157 24.4993 24.768 24.4993 24.2157V17.9477ZM23.6285 27.1153C22.6302 27.1153 21.8208 27.9247 21.8208 28.923C21.8208 29.9214 22.6302 30.7307 23.6285 30.7307C24.6269 30.7307 25.4362 29.9214 25.4362 28.923C25.4362 27.9247 24.6269 27.1153 23.6285 27.1153Z",
    fill: "#F09700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWarn);
export default __webpack_public_path__ + "static/media/ico-warn.bcc0c18d0603392f145efd19f8280e7b.svg";
export { ForwardRef as ReactComponent };